/**
 * Short names for narrow cells. Lives apart from `LastActivityCell.tsx` so that file only exports
 * components (the `react-refresh/only-export-components` rule flags mixed exports, as it did for
 * `features/preinvest/financialdd/sectionIds.ts`); the columns of Contacten and Organisaties
 * import it from here.
 */

/** Dutch name particles: "Jan Geert van Hall" is "Jan Geert" in a narrow cell. */
const PARTICLES = new Set(['van', 'de', 'der', 'den', 'ten', 'ter', 'te', 'het', "'t", 'op', 'in', 'von', 'du', 'la', 'le'])

/** The words before the first lower-case particle ("Jan Geert van Hall" → "Jan Geert"), else the first word. */
export function shortName(fullName: string): string {
  const words = fullName.trim().split(/\s+/).filter(Boolean)
  const particle = words.findIndex((word, index) => index > 0 && PARTICLES.has(word.replace(/’/g, "'")))
  return words.slice(0, particle > 0 ? particle : 1).join(' ')
}
